import React from "react";
import styled from "styled-components";
import moment from "moment";

// Componentes estilizados
const BenefitDetailContainer = styled.div`
    background: white;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    bottom: 0;
    height: 98%;
    left: 0;
    overflow: auto;
    padding-bottom: 3em;
    padding-left: 5em;
    padding-right: 5em;
    padding-top: 3em;
    position: fixed;
    text-align: center;
    transform: translateY(${props => props.visible ? `0` : `100%`});
    transition: all 0.5s;
    width: 100%;
    z-index: 1050;

    body.theme-market & {
        background: var(--page-bg);
        color: var(--text-primary);
    }

    body.theme-platinum & {
        background: var(--primary-b);
        color: var(--text-primary);
    }
`;

const CloseCross = styled.button`
    position: absolute;
    right: 0.5em;
    top: 0.5em;
    background: none;
    border: none;
    outline: none;
    font-size: 1.5em;
    color: var(--text-color);

    &:focus { outline: none; }
`;

const BenefitDetailContent = styled.div`
    margin: 0 auto 2em;
    max-width: 800px;
    text-align: center;
`;

const BenefitBalanceContainer = styled.div`
    border-radius: 10px;
    padding: 0 1.5rem;
    margin-bottom: 3rem;
`;

const BenefitBalanceTitle = styled.div`
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 0.5rem;

    body.theme-market &,
    body.theme-platinum & {
        color: var(--primary);
    }
`;

const BenefitBalance = styled.div`
    font-family: var(--ff-subtitle);
    font-size: 40px;
    font-weight: 700;
    color: var(--text-primary);
`;

const BenefitTitle = styled.h4`
    color: var(--text-primary);
    font-family: var(--ff-title);
    font-size: 50px;
    margin-bottom: 1rem;
    text-transform: uppercase;
    
    body.theme-market &,
    body.theme-platinum & {
        color: var(--primary);
    }
`;

const BenefitDescription = styled.div`
    line-height: 25px;
`;

const CinemaListContainer = styled.div`
    margin-top: 8rem;
    text-align: center;
`;

class BenefitDetail extends React.Component {
    get currentBenefit() {
        return this.props.benefit || {};
    }

    render() {
        const { visible, onClose } = this.props;

        const benefit = this.currentBenefit;

        return (
            <BenefitDetailContainer visible={visible}>
                <CloseCross onClick={onClose}><i className="fal fa-times"></i></CloseCross>
                <BenefitDetailContent>
                    {benefit.display_balance && !benefit.cinemas.length && (
                        <BenefitBalanceContainer>
                            <BenefitBalanceTitle>Saldo Disponible:</BenefitBalanceTitle>
                            <BenefitBalance>
                                {benefit.balance || 0}
                            </BenefitBalance>
                            {benefit.display_expiration_date && (
                                <p>
                                    {benefit.balance_expiration_date_string}
                                </p>
                            )}
                            {benefit.display_renewal_label && (
                                <p>
                                    {benefit.renewal_label}
                                </p>
                            )}
                        </BenefitBalanceContainer>
                    )}

                    <BenefitTitle>
                        {benefit.title || 'Detalle del beneficio'}
                    </BenefitTitle>

                    <BenefitDescription dangerouslySetInnerHTML={{__html: benefit.description}} />
                    
                    {benefit.display_balance && benefit.cinemas && benefit.cinemas.length > 0 && (
                        <CinemaListContainer>
                            {benefit.display_renewal_label && (
                                <p>
                                    {benefit.renewal_label}
                                </p>
                            )}

                            {benefit.cinemas.map((cinema, index) => (
                                <p key={index}>
                                    {cinema.name} — <b>Saldo: {cinema.balance}</b> — {cinema.balance_expiration_date ? `Vencimiento: ${cinema.balance_expiration_date.split('-').reverse().join('/')}` : ''}
                                </p>
                            ))}
                        </CinemaListContainer>
                    )}
                </BenefitDetailContent>
            </BenefitDetailContainer>
        );
    }
}

export default BenefitDetail;